if (signedIn) {
    if (!localStorage.getItem('signedIn')) {
        if (submitTag){
            window.dataLayer.push({
                event: 'user_login_success',
                method: 'email'
            });
        }
        localStorage.setItem('signedIn', true);
    }
} else {
    if (localStorage.getItem('signedIn')) {
        localStorage.removeItem('signedIn');
    }
}

$(document).ready(function() {
    $('#loginBtn').on('click',function(){
        if (submitTag){
            window.dataLayer.push({
                event: 'user_attempt_login',
                method: 'email'
            });
        }
    });

    $('#faqs-link').on('click', function(){
        if (submitTag){
            window.dataLayer.push({
              'event': 'faqs_page_click',
              'event_id': 'faqs_click_' + new Date().getTime(),
              'page_path': window.location.pathname,
              'timestamp': new Date().toISOString()
            });
        }
    });

    $('.social-links a[data-name]').on('click', function(){
        if(submitTag){
            window.dataLayer.push({
                'event': 'social_icon_click',
                'event_id': 'social_click_' + new Date().getTime(),
                'social_network': $(this).data('name'),
                'page_path': window.location.pathname,
                'timestamp': new Date().toISOString()
            });
        }
    });
});

if (loginFailed && submitTag){
    window.dataLayer.push({
        event: 'user_login_fail',
        method: 'email'
      });
}